import { render, staticRenderFns } from "./EmailNotificationGroupsList.vue?vue&type=template&id=5a5db828"
import script from "./EmailNotificationGroupsList.vue?vue&type=script&lang=js"
export * from "./EmailNotificationGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports